import { useFeature } from 'flagged';
const useTournamentsV2Designs = (gameKey) => {
    const isLoLUIv2Enabled = useFeature('enable_tournament_v2_design');
    const isRocketLeagueUIv2Enabled = useFeature('enable_tournament_v2_design_rocket-league');
    return (Boolean(isLoLUIv2Enabled && gameKey === 'league_of_legends') ||
        Boolean(isRocketLeagueUIv2Enabled && gameKey === 'rocket-league') ||
        Boolean(gameKey === 'madden-25') ||
        Boolean(gameKey === 'madden-26') ||
        Boolean(gameKey === 'battlefield-6'));
};
export default useTournamentsV2Designs;
